import React, { useEffect } from "react"
import { useParams } from "react-router-dom"
import { AddressListSection } from "./AddressListSection"
import { ProfileAddressPupop } from "../Pupop/ProfileAddressPupop"
import { useCustomerAddresses } from "../../hooks/Costumer/useCustomerAddresses"
import { AddressEntity } from "../../Objects/Person/AddressEntity"

type AddressChangeEvent = {
  type: "add" | "update" | "delete"
  addressId?: number
}

interface AddressManagerProps {
  title?: string
  emptyLabel?: string
  selectedAddressId?: number
  onClick?: (address: AddressEntity) => void
  onAddressesChanged?: (event: AddressChangeEvent) => void
}

export const AddressManager: React.FC<AddressManagerProps> = ({
  title,
  emptyLabel,
  selectedAddressId,
  onClick,
  onAddressesChanged,
}) => {
  const { storeSlug } = useParams<{ storeSlug: string }>()

  const {
    addresses,
    selectedAddress,
    showAddressModal,
    openAddAddress,
    openEditAddress,
    closeModal,
    addOrUpdateAddress,
    deleteAddress,
  } = useCustomerAddresses(storeSlug)

  useEffect(() => {
    document.body.style.overflow = showAddressModal ? "hidden" : "unset"
    return () => {
      document.body.style.overflow = "unset"
    }
  }, [showAddressModal])

  return (
    <>
      <AddressListSection
        title={title}
        emptyLabel={emptyLabel}
        addresses={addresses}
        onClick={onClick}
        onAdd={() => {
          openAddAddress()
        }}
        onEdit={(e) => {
          openEditAddress(e)
        }}
        onDelete={(e) => {
          deleteAddress(e)
          onAddressesChanged?.({
            type: "delete",
            addressId: e.id,
          })
        }}
        selectedAddressId={selectedAddressId}
      />

      {showAddressModal && (
        <ProfileAddressPupop
          value={addresses}
          addressEntity={selectedAddress}
          onChange={(list) => {
            addOrUpdateAddress(list)
            onAddressesChanged?.({
              type: selectedAddress ? "update" : "add",
              addressId: selectedAddress?.id,
            })
          }}
          onClose={closeModal}
        />
      )}
    </>
  )
}
